import React from 'react';
import './index.scss';
import MetricsCardWrap from '../../components/MetricsCardWrap';
import MetricsCardValue, { IMetricsCardValue } from '../../components/MetricsCardValue';
import MetricsCardDod, { IMetricsDod } from '../../components/MetricsCardDod';
import NoData from '../NoData';

interface IMetricsCardWrap {
  // 类名
  className?: string;
  // 样式
  style?: React.CSSProperties;
  // 中英文标题
  titleEn: string;
  titleCn: string;
  // 中英文副标题
  subtitleEn?: string;
  subtitleCn?: string;
  // 跳转链接
  link?: string;
  // 标题旁图标(SvgIcon引入)
  icon?: string;
  // 标题旁图标（getImg项目图标引入）
  titleIcon?: string;
  // 标题旁图片地址
  imgUrl?: string;
  // 是否开启icon的info提示（与标题hover的提示互斥）
  isIconTips?: boolean;
  // 中英文指标注释
  tipsEn?: string;
  tipsCn?: string;
  // 头部组件
  contentHeader?: React.ReactNode;
  // 尾部组件
  contentFooter?: React.ReactNode;
  // 是否显示箭头图标
  showArrowIcon?: boolean;
  // 是否显示数值颜色
  showValueColor?: boolean;
}

interface IMetricsCardDod {
  // 类名
  dodClassName?: string;
  // 样式
  dodStyle?: React.CSSProperties;

  dodData?: IMetricsDod[];
}
interface IMetricsCard extends IMetricsCardWrap, IMetricsCardValue, IMetricsCardDod {
  valueStyle?: React.CSSProperties;
  metricsChart?: JSX.Element;
  valueClassName?: string;
  children?: JSX.Element;
  showNoData?: boolean;
  nodataMsg?: string;
}


const MetricsCard = (props: IMetricsCard) => {
  const {
    titleEn,
    titleCn,
    subtitleEn,
    subtitleCn,
    icon,
    titleIcon,
    imgUrl,
    link,
    tipsEn,
    tipsCn,
    isIconTips,
    contentHeader,
    contentFooter,
    metricsChart,
    valueClassName,
    valueStyle,
    value,
    formatRule,
    titleFormatRule,
    emptyValue,
    preUnit,
    endUnit,
    dodClassName,
    dodStyle,
    dodData,
    style,
    className,
    children,
    showNoData,
    nodataMsg,
    showArrowIcon,
    showValueColor,
  } = props;

  return (
    <MetricsCardWrap
      titleCn={titleCn}
      titleEn={titleEn}
      className={className}
      style={style}
      link={link}
      tipsEn={tipsEn}
      tipsCn={tipsCn}
      icon={icon}
      titleIcon={titleIcon}
      imgUrl={imgUrl}
      isIconTips={isIconTips}
      subtitleEn={subtitleEn}
      subtitleCn={subtitleCn}
      contentHeader={contentHeader}
      contentFooter={contentFooter}
    >
      {showNoData ? (
        <NoData className = "dbd-metrics-card-no-data" text={ nodataMsg||'' } />
      ) : (
        <>
          <div className="dbd-metrics-card__flex dbd-metrics-card__row">
            <div className="dbd-metrics-card__flex">
              <MetricsCardValue
                className={valueClassName}
                style={valueStyle}
                value={value}
                formatRule={formatRule}
                titleFormatRule={titleFormatRule}
                emptyValue={emptyValue}
                preUnit={preUnit}
                endUnit={endUnit}
                showArrowIcon={showArrowIcon}
                showValueColor={showValueColor}
              />
              <MetricsCardDod
                className={dodClassName}
                style={dodStyle}
                data={dodData}
              />
            </div>
            {metricsChart}
          </div>
          {children}
        </>
      )}
    </MetricsCardWrap>
  );
};

export default MetricsCard;